import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyPayment } from '../lib/marketOrdersApi';

// HioBuy phase 3 — PAYMENT SIMULATOR, test environments only. It stands in for
// the payment provider's hosted page so the whole order flow can be exercised
// without money. The server refuses it unless BOTH market_settings.payments_mode
// is 'mock' AND the function's environment sets MARKET_ALLOW_MOCK_PAY=1, which
// production never does; routed only under REACT_APP_MARKET_PREVIEW.

export default function MarketPayMock() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const order = params.get('order'), payment = params.get('payment');

  const finish = async (result) => {
    setBusy(true); setErr('');
    const r = await verifyPayment(order, payment, result);
    // Return the way Telr does — with the payment id — so the order page asks the
    // server to verify and shows the outcome (it never trusts the return alone).
    if (r.ok || r.httpStatus === 402) { nav(`/market/orders/${order}?payment=${encodeURIComponent(payment)}`, { replace: true }); return; }
    setBusy(false); setErr(r.error || 'error');
  };

  return (
    <div className="full-page" dir="rtl">
      <div className="fx-wrap" style={{ maxWidth: 520 }}>
        <div data-mock-pay="1" style={{ border: '2px dashed #B3261E', borderRadius: 16, padding: 24, marginTop: 30, fontFamily: 'var(--font-ar)', background: 'var(--surface-raised)' }}>
          <h1 style={{ fontSize: 20, margin: '0 0 8px' }}>محاكي الدفع — بيئة اختبار</h1>
          <p style={{ fontSize: 13.5, color: 'var(--text-secondary)', lineHeight: 1.8 }}>
            هذه الصفحة تحاكي صفحة بوابة الدفع. لا يُخصم أي مبلغ ولا تُنشأ أي عملية حقيقية. الخادم يرفضها خارج بيئة الاختبار.
          </p>
          <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
            <button type="button" data-mock-approve="1" disabled={busy} onClick={() => finish('approved')}
              style={{ flex: 1, padding: '12px 0', borderRadius: 12, border: 'none', background: '#2E7D32', color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--font-ar)' }}>محاكاة دفع ناجح</button>
            <button type="button" data-mock-decline="1" disabled={busy} onClick={() => finish('declined')}
              style={{ flex: 1, padding: '12px 0', borderRadius: 12, border: '1px solid var(--border-strong)', background: 'var(--surface-raised)', fontSize: 14, cursor: 'pointer', fontFamily: 'var(--font-ar)' }}>محاكاة رفض</button>
          </div>
          {err && <p style={{ color: '#B3261E', fontSize: 12.5 }}>{err}</p>}
        </div>
      </div>
    </div>
  );
}
